import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

interface RightAssetProps {
  imageUrl?: string;
  visible: boolean;
}

interface LeftProps {
  padding: boolean;
}

interface RollingContainerProps {
  visible: boolean;
}

interface RollingItemProps {
  active: boolean;
}

export const Container = styled.div`
  display: flex;
  min-height: 100vh;
`;

export const Left = styled.div<LeftProps>`
  background: ${ColorPalette.HEX.White};

  display: flex;
  flex-direction: column;
  padding: ${({ padding }) => (padding ? '50px 50px 50px 50px' : '50px 135px 50px 90px')};

  flex: 1;
  max-width: 50%;
`;

export const Logo = styled.img`
  width: 120px;
  height: 60px;
  margin: 16px auto;
  object-fit: contain;
`;

export const Content = styled.div`
  margin: auto 0;
`;

export const Right = styled.div`
  background: ${({ theme }) => theme.secondaryBackgroundColor};

  display: flex;
  align-items: center;
  justify-content: center;

  flex: 1;
  max-width: 50%;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;

    width: 50%;
    background-image: url('/corporate/images/clouds.svg');
    background-position: right -75px bottom -320px;
    background-size: 1750px;
    background-repeat: repeat-x, no-repeat, no-repeat, no-repeat;
    opacity: 10%;
    z-index: 0;
  }
`;

export const RightContent = styled.div`
  max-width: 80%;
  height: 500px;
  overflow: hidden;
`;

export const RightAsset = styled.div<RightAssetProps>`
  position: sticky;
  top: 0;
  background-image: url(${({ imageUrl }) => imageUrl});
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  max-width: 500px;
  height: 100%;
  opacity: ${({ visible }) => (visible ? '100%' : '0%')};
  transition: opacity ease-in-out 0.5s;
  margin: auto;
`;

export const RollingContainer = styled.div<RollingContainerProps>`
  position: relative;
  overflow: hidden;
  height: 100%;
  opacity: ${({ visible }) => (visible ? '100%' : '0%')};
  transition: opacity ease-in-out 0.5s;
`;

export const RollingGradient = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  z-index: 0;
  height: 100%;

  background: linear-gradient(
    0deg,
    ${({ theme }) => theme.secondaryBackgroundColor} 0%,
    transparent 30%,
    transparent 70%,
    ${({ theme }) => theme.secondaryBackgroundColor} 100%
  );
`;

export const RollingStub = styled.div`
  height: 500px;
`;

export const RollingItems = styled.div``;

export const RollingItem = styled.div<RollingItemProps>`
  display: flex;
  align-items: center;
  position: relative;

  color: ${ColorPalette.HEX.White};
  font-weight: 600;
  font-size: 40px;
  line-height: 48px;
  margin: 60px 0;

  opacity: ${({ active }) => (active ? 100 : 40)}%;
  transition: opacity ease-in-out 0.5s;
`;
